"use client";

import React from "react";

import { Input } from "@/dashboard/components/ui/input";

export interface DateInputFieldProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onFocus: () => void;
  autoFocus?: boolean;
  hasError?: boolean;
}

export const DateInputField: React.FC<DateInputFieldProps> = ({
  id,
  value,
  onChange,
  onBlur,
  onFocus,
  autoFocus,
  hasError = false,
}) => {
  return (
    <div
      className={`relative cursor-pointer transition-colors rounded-md ${
        hasError ? "bg-red-50 hover:bg-red-100" : "hover:bg-muted/50"
      }`}
      onClick={() => {
        onFocus();
      }}
    >
      <Input
        id={id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        className={`h-9 text-center ${
          hasError
            ? "border-red-300 hover:border-red-400 focus:border-red-500 focus:ring-red-500"
            : "hover:border-primary"
        }`}
        autoFocus={autoFocus}
      />
    </div>
  );
};
